import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '../shared/shared.module'
import { ToggleMenuComponent } from './toggle-menu/toggle-menu.component'
import { ContentRowsComponent } from './content-rows/content-rows.component'
import { RouterModule } from '@angular/router'
import { DynamicsModuleModule } from '../dynamics-module/dynamics-module.module'
import { MultilevelMenuModule } from '../multilevel-menu/multilevel-menu.module'
import { MobileMenuComponent } from './mobile-menu/mobile-menu.component'
import { ItemMenuComponent } from './item-menu/item-menu.component'
import { WebsiteHeaderV2Component } from './website-header-v2.component'
import { NgxJsonLdModule } from 'ngx-json-ld'
import { CollapseMobileMenuComponent } from './mobile-menu/collapse-mobile-menu/collapse-mobile-menu.component';
import { HorizontalMobileMenuComponent } from './mobile-menu/horizontal-mobile-menu/horizontal-mobile-menu.component'
import { PipesModule } from '../../pipes/pipes.module'



@NgModule({
  declarations: [
    WebsiteHeaderV2Component,
    ToggleMenuComponent,
    ContentRowsComponent,
    MobileMenuComponent,
    ItemMenuComponent,
    CollapseMobileMenuComponent,
    HorizontalMobileMenuComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    DynamicsModuleModule,
    MultilevelMenuModule,
    NgxJsonLdModule,
    PipesModule
  ],
  exports: [WebsiteHeaderV2Component]
})
export class WebsiteHeaderV2Module { }
